/* global $ */

import React, { useEffect, useState } from 'react';
import { makeAPI } from '../../services/api';
import useResponsive from '../custom_hooks/useResponsive';
// import { toast } from 'react-toastify';
// import { browserPopupRedirectResolver } from 'firebase/auth';
// import { useGlobalState, useGlobalDispatch } from '../../contexts/user';
import { useLocation } from 'react-router-dom';
// import ViewButton from '../../pages/view_button';
import PurchaseConfirmation from './purchase_confirmation';
import PhoneVerificationModal from '../common/phone_verification_modal';
// import Swal from 'sweetalert2';
// var user = JSON.parse(localStorage.getItem("user"));
import coin from "../../assets/img/icons/coin.avif";
import fallback_img from "../../assets/img/fallback/store.avif";

const CouponPreview = ({ onClose }) => {
    const location = useLocation();
    const { state } = location;
    let couponData = state;
    let isMobile = useResponsive();
    const [user, setUser] = useState(() => getStoredUser());
    // const { user } = useGlobalState();
    // const dispatch = useGlobalDispatch();
    const [price, setprice] = useState(couponData?.price);
    const [onclose, setonclose] = useState(false);
    const [voucher_code, setvoucher_code] = useState({});
    const [quantity_value, setquantity_value] = useState(1);
    const [support_creator, setsupport_creator] = useState(false);
    const [activeAccordion, setActiveAccordion] = useState(isMobile ? null : "coupon-details");
    const [showRedeemModal, setShowRedeemModal] = useState(false);
    const [redeemBusy, setRedeemBusy] = useState(false);
    const [redeemError, setRedeemError] = useState("");
    const [redeemPayload, setRedeemPayload] = useState(null);
    const [showPhoneVerification, setShowPhoneVerification] = useState(false);
    const [pendingRedeemPayload, setPendingRedeemPayload] = useState(null);
    let platform_coin_value = couponData?.platform_coin_value || 10;
    // console.log("coupondata",couponData);

    useEffect(() => {
        price_updation(couponData);
        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
        scrollToTop();
    }, []);
    useEffect(() => {
        // console.log("Updated:", quantity_value, price);
        setprice(quantity_value * price_updation(couponData, couponData?.price, platform_coin_value));
    }, [quantity_value, price]);
    useEffect(() => {
        // get creator status.
        const CreatorStatus = async () => {
            // let check_stat = await GetSupportedCreatorCode(user?.user_id);
            // if (check_stat.verified_creator === true) {
            //     // alert()
            //     setsupport_creator(true);
            // }
        }
        CreatorStatus();
    })
    useEffect(() => {
        const syncUser = () => setUser(getStoredUser());
        window.addEventListener("auth:updated", syncUser);
        return () => window.removeEventListener("auth:updated", syncUser);
    }, []);
    if (!state) {
        return window.location.href = '/'
    }
    const refreshUserData = async (email) => {
        if (!email) return null;
        const userDataRes = await makeAPI("/api/get_user_data", "POST", true, { email });
        if (userDataRes?.status === "S" && userDataRes?.data) {
            localStorage.setItem("user", JSON.stringify(userDataRes.data));
            setUser(userDataRes.data);
            window.dispatchEvent(new CustomEvent("auth:updated"));
            return userDataRes.data;
        }
        return null;
    };

    const redeem_click = async (couponData, user, price) => {
        const currentUser = getStoredUser() || user;
        // onClose()
        // before price value 
        let value = document.querySelector(".shop-redeem input:checked");
        let remove_currency = [];
        if (value !== null) {
            // toast.error("Please select denomination value to redeem the voucher.");
            let label = document.querySelector(`label[for="${value?.id}"]`);
            remove_currency = label.textContent.split('₹');
        } else {
            remove_currency[1] = couponData?.price;
        }



        let product_id = couponData?.product_id;
        if (!currentUser || !currentUser?.user_id) {
            // alert("Please login..!"); //toast
            const openModal = () => {
                if (window.UIkit && typeof window.UIkit.modal === "function") {
                    window.UIkit.modal("#modal-login", { container: false }).show();
                }
            };
            openModal();
            return;
        }

        let latestUser = currentUser;
        try {
            const fetched = await refreshUserData(currentUser?.email);
            if (fetched) {
                latestUser = fetched;
            }else{
                // return false not show redeem popup.
                return null;
            }
        } catch (error) {
            console.log("Failed to refresh user data before redeem:", error);
            console.error("PRODUCT PREVIEW",error)
        }

        let current_choose_val = price_updation(couponData, price, platform_coin_value);

        if (Number(latestUser?.coin_balance || 0) >= current_choose_val) {
            console.log("purchase coin will be valid here move to another steps.");
        }
        else {
            // onClose()
            return alert("Enough balance is needed to redeem the voucher."); //toast
        }

        const nextRedeemPayload = {
            product_id,
            remove_currency,
            currentUser: latestUser,
            price
        };

        // Enable OTP functionality && verification.

        // if (latestUser?.phone_verified !== true) {
        //     setPendingRedeemPayload(nextRedeemPayload);
        //     setShowPhoneVerification(true);
        //     return;
        // }

        setRedeemError("");
        setRedeemPayload(nextRedeemPayload);
        setShowRedeemModal(true);
    }

    const confirmRedeem = async () => {
        if (!redeemPayload) return;
        try {
            setRedeemBusy(true);
            setRedeemError("");
            let redeem = await purchaseProduct(
                redeemPayload.product_id,
                redeemPayload.remove_currency[1],
                redeemPayload.currentUser.user_id,
                couponData?.coupon_type,
                quantity_value
            );
            if (redeem.status === "S") {
                alert("Voucher Redeemed Successfully!");//toast
                setvoucher_code(redeem?.voucher_code || "");
                setonclose(true);
                setShowRedeemModal(false);
                couponData.purchase_stat = redeem.purchase_stat || "";
                const updatedUser = {
                    ...redeemPayload.currentUser,
                    coin_balance: (Number(redeemPayload.currentUser?.coin_balance || 0) - Number(redeemPayload.price || 0))
                };
                localStorage.setItem("user", JSON.stringify(updatedUser));
                setUser(updatedUser);
                window.dispatchEvent(new CustomEvent("auth:updated"));
                return;
            }
            setonclose(false);
            setRedeemError(redeem?.message || "Redeem failed. Please try again.");
        } catch (error) {
            setRedeemError(error?.message || "Something went wrong. Please try again.");
        } finally {
            setRedeemBusy(false);
        }
    }
    function quantity_onclick(stat) {
        return false;
        var value = document.getElementById('quantity_value');
        if (stat === "minus") {
            if (quantity_value > 1) {
                // setprice(quantity_value * price_updation(couponData, price,platform_coin_value));
                setquantity_value((quantity_value) => quantity_value - 1);
                // setquantity_value(quantity_value - 1);
            } else {
                setquantity_value(1);
            }
        } else if (stat === "plus" && couponData?.quantity > quantity_value) {
            // console.log("quanity $ price",quantity_value , price);
            // setprice(quantity_value * price_updation(couponData, price,platform_coin_value));
            setquantity_value((quantity_value) => quantity_value + 1);
        }
    }


    return (
        <>
            <style>
                {`
           
    .ticket-accordion {
    background: #161616;
    padding: 25px 30px;
    margin-bottom: 20px;
    border-radius: 7px
}

.ticket-accordion .accordion-headers {
    padding: 0;
    line-height: 1;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 0
}

.ticket-accordion .accordion-headers .accordion-buttons {
    background-color: transparent;
    width: 100%;
    text-align: left;
    color: #fff;
    border: 0;
    padding: 0;
    position: relative;
    font-weight: 600
}

.ticket-accordion .accordion-headers .accordion-buttons .down-arrow {
    position: absolute;
    right: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    transition: transform .28s ease
}

.ticket-accordion .accordion-body {
    padding: 15px 0 0
}

.ticket-accordion .accordion-buttons.expanded .down-arrow {
    transform: translateY(-50%) rotate(180deg)
}

.ticket-accordion .accordion-panel {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-height .35s ease, opacity .25s ease
}

.ticket-accordion .accordion-panel.open {
    max-height: 2000px;
    opacity: 1
}
    .accordion-body {
    line-height:32px;
    }

    .redeem-confirm-modal {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    padding: 16px;
    }

    .redeem-confirm-card {
    position: relative;
    width: 100%;
    max-width: 480px;
    background: #161616;
    border: 1px solid #303030;
    border-radius: 10px;
    padding: 20px;
    color: #fff;
    }

    .redeem-confirm-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 16px;
    }

    .uk-button-default
    {
      color:#ffffff;
      border: 1px solid #ff810e
    }

    .uk-modal-close-default
    {
        position: absolute;
        padding:0px 6px 0px 6px;
        background-color:#161616 !important;
        border:1px solid #ff810e;
        color:#fff;
    }

    .uk-modal-close-default:hover
    {
       background-color:#ff810e !important;
    }


            `}
            </style>
            <p className='container card text-white' style={{backgroundColor:"transparent",cursor:"pointer"}} onClick={()=>{
                window.history.back();
            }}>{"<- BACK"}</p>
            <div className="container card" style={{ marginTop: "0px", backgroundColor: '#161616' }} id='overflow-container'>
                <div className="row">
                    <div className='col-lg-4 col-12'>
                        <div className='container-fluid' style={{ color: '#fff', padding: '20px', borderRadius: '8px' }}>
                            <div className="coupon-banner w-100">
                                <img src={`${couponData?.thumb_img}`} onError={(e) => {
                                    e.currentTarget.onerror = null; // prevent infinite loop if fallback also errors
                                    e.currentTarget.src = fallback_img;
                                }} style={{ borderRadius: "8px" }}
                                    alt="Coupon Banner" className="img-fluid w-80" />
                            </div><br />
                            <div className=" justify-content-between align-items-center mb-2">
                                <h5 className="fw-bold mb-3">{couponData?.title}</h5>

                                {couponData?.btn_text !== "Redeem" ? <h6 className='mb-3'>Choose value :</h6> : ""}
                                {couponData?.btn_text !== "Redeem" ? <div className=' d-flex flex-wrap shop-redeem' role="group" aria-label="Denominations" >
                                    {couponData?.denomination ? (couponData?.denomination.split(",").sort(function (a, b) { return a - b }).map((data, index) => {
                                        if (data === "0" || couponData?.btn_text === "Redeem") {
                                            // return null;
                                            data = couponData?.price.toString();
                                        }
                                        return (
                                            < >
                                                <input type='radio' className='btn-check ' name='denomination' id={`demon-${index}`} autoComplete='off' defaultChecked={index === 0} onChange={() => {
                                                    let return_data = price_updation(data, price, platform_coin_value)
                                                    setprice(return_data);
                                                }
                                                } />
                                                <label className=' btn-base btn-sm  mx-1  mb-3' htmlFor={`demon-${index}`} style={{ color: "white" }}>
                                                    ₹{data.trim()}
                                                </label>
                                            </>
                                        );
                                    })) : (<h6>No Denomination will avaialble</h6>)
                                    }
                                </div> : ""}

                                <br></br>
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h5 className="fw-bold mb-0" id='dir-denom-value' style={{ width: "fit-content" }}>Price: &nbsp;{price} <img src={coin} style={{ width: '20px', height: '25px', paddingBottom: '5px' }} alt='' /></h5>
                                {couponData?.btn_text !== "Redeem" ?
                                    <div class="media product-cart-inner" style={{ borderBottom: "0px", paddingBottom: "0px", marginBottom: "0px", border: "1px solid #1a2016", cursor: "pointer",visibility:'hidden' }}>
                                        <div class="media-body align-self-center" >
                                            <div class="color-plate" >
                                                <div class="quantity-wrap" >
                                                    <div class="quantity" style={{ border: "1px solid #ff810e" }}>
                                                        <input type="number" step="1" min="0" max={couponData?.quantity} value={quantity_value} title="Qty" class="input-text qty text" id='quantity_value' style={{ paddingLeft: "15px" }} />
                                                        <a class="inc qty-button" onClick={() => { quantity_onclick("plus") }}>+</a><a class="dec qty-button" onClick={() => { quantity_onclick("minus") }}>-</a></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : ""}
                            </div>

                            <hr />
                            <div className='d-flex justify-content-between '>
                                <p className="">{couponData?.sub_title}</p>
                                <p className="">Expires in : {couponData?.expires_in ? couponData?.expires_in.replace(/<\/?[^>]+(>|$)/g, "").replace(/&[^;]+;/g, " ").trim() : "NA"}</p>

                            </div>
                            {/* <span className="text-muted">{couponData.sub_title}</span> 
                        <span className="text-muted">{couponData.sub_title}</span> */}
                            <p style={{ color: "#ff810e" }}>Note: Before redeem the Voucher, please read the terms & conditions.</p>
                            <center>
                                <div className="right">
                                    {/* {couponData?.btn_text === "Coming Soon" ?
                                        <a className='btn btn-base ' aria-disabled style={{ color: "#fff" }} onClick={(event) => {
                                            redeem_click(couponData, user, price, dispatch);
                                        }}>Coming Soon</a> */}
                                    {/* : */}
                                    <button className="" style={{ padding: "5px 10px", fontSize: "14px", background:'#ff810e', outline:'none', border:'none', color:'#ffffff',fontWeight:'bold',borderRadius:'4px' }} onClick={(event) => {
                                        redeem_click(couponData, user, price);
                                    }}>Redeem&nbsp;<i className="fa-solid fa-arrow-right"></i></button>
                                    {/* <a className="btn btn-base" style={{ color: "#fff" }} onClick={(event) => {
                                        redeem_click(couponData, user, price, dispatch);
                                    }}>Redeem <i className="fa fa-arrow-right"></i></a> */}
                                    {/* } */}
                                    {/* <a className="btn btn-base" style={{ color: "#fff" }} onClick={(event) => {
                                    redeem_click(couponData, user, price, dispatch);
                                }}>Redeem <i className="fa fa-arrow-right"></i></a>&nbsp; */}
                                    {/* {couponData?.redeem_link ? <a className="btn btn-base" style={{ color: "#fff" }} onClick={(event) => {
                                    window.open(couponData?.redeem_link, "_blank");
                                }}>Link <i className="fa fa-arrow-right"></i></a> : ""} */}
                                </div>
                            </center>
                        </div>
                    </div>
                    <div className='col-lg-8 col-12'>
                        {/* <div className="" > */}
                        <div className="p-5" >
                            <h5 className='p-3'>Details & Frequently Asked Questions</h5>
                            <hr />

                            <div className="accordion-wrapper" id="accordionExample">
                                <div className="ticket-accordion accordion-items" style={{ padding: '15px' }}>
                                    <h2 className="accordion-headers " id="heading-coupon-details" >
                                        <button
                                            className={`accordion-buttons d-flex justify-content-between align-items-center text-wrap w-100 ${activeAccordion === "coupon-details" ? "expanded" : ""}`}
                                            type="button"
                                            onClick={() => setActiveAccordion(activeAccordion === "coupon-details" ? null : "coupon-details")}
                                            aria-expanded={activeAccordion === "coupon-details"}
                                            aria-controls="coupon-details"
                                        >
                                            {/* {item.data.question} */}
                                            <span className="me-2" style={{ fontSize: '18px' }}>Coupon Details</span>
                                            <i className="fa fa-angle-down down-arrow"></i>
                                        </button>
                                    </h2>
                                    <div id="coupon-details" className={`accordion-panel ${activeAccordion === "coupon-details" ? "open" : null}`} aria-labelledby="heading-coupon-details">
                                        <div className="accordion-body" style={{ fontSize: '18px', color: "#cdcdcd" }}>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: couponData?.coupon_details }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="ticket-accordion accordion-items" style={{ padding: '15px' }}>
                                    <h2 className="accordion-headers " id="heading-how-to-redeem">
                                        <button
                                            className={`accordion-buttons d-flex justify-content-between align-items-center text-wrap w-100 ${activeAccordion === "how-to-redeem" ? "expanded" : ""}`}
                                            type="button"
                                            onClick={() => setActiveAccordion(activeAccordion === "how-to-redeem" ? null : "how-to-redeem")}
                                            aria-expanded={activeAccordion === "how-to-redeem"}
                                            aria-controls="how-to-redeem"
                                        >
                                            {/* {item.data.question} */}
                                            <span className="me-2" style={{ fontSize: '18px' }}>How to Redeem</span>
                                            <i className="fa fa-angle-down down-arrow"></i>
                                        </button>
                                    </h2>
                                    <div id="how-to-redeem" className={`accordion-panel ${activeAccordion === "how-to-redeem" ? "open" : ""}`} aria-labelledby="heading-how-to-redeem">
                                        <div className="accordion-body" style={{ fontSize: '18px', color: "#cdcdcd" }}>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: couponData?.how_to_redeem }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="ticket-accordion accordion-items" style={{ padding: '15px' }}>
                                    <h2 className="accordion-headers " id="heading-terms-conditions">
                                        <button
                                            className={`accordion-buttons d-flex justify-content-between align-items-center text-wrap w-100 ${activeAccordion === "terms-conditions" ? "expanded" : ""}`}
                                            type="button"
                                            onClick={() => setActiveAccordion(activeAccordion === "terms-conditions" ? null : "terms-conditions")}
                                            aria-expanded={activeAccordion === "terms-conditions"}
                                            aria-controls="terms-conditions"
                                        >
                                            {/* {item.data.question} */}
                                            <span className="me-2" style={{ fontSize: '18px' }}>Terms & Conditions</span>
                                            <i className="fa fa-angle-down down-arrow"></i>
                                        </button>
                                    </h2>
                                    <div id="terms-conditions" className={`accordion-panel ${activeAccordion === "terms-conditions" ? "open" : ""}`} aria-labelledby="heading-terms-conditions">
                                        <div className="accordion-body" style={{ fontSize: '18px', color: "#cdcdcd" }}>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: couponData?.terms_and_conditions }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* </div> */}
                    </div>

                </div>
            </div >
            {showRedeemModal && (
                <div
                    className="redeem-confirm-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="redeem-confirm-title"
                    onClick={() => {
                        if (redeemBusy) return;
                        setShowRedeemModal(false);
                        setRedeemError("");
                    }}
                >
                    <div className="redeem-confirm-card" onClick={(event) => event.stopPropagation()}>
                        <button
                            type="button"
                            className="uk-modal-close-default"
                            aria-label="Close"
                            onClick={() => {
                                if (redeemBusy) return;
                                setShowRedeemModal(false);
                                setRedeemError("");
                            }}
                            >x</button>
                        <h5 id="redeem-confirm-title" style={{ marginBottom: "12px" }}>Are you sure?</h5>
                        <p style={{ marginBottom: "8px" }}>
                            You are about to redeem <span style={{ color: "#ff810e" }}>"{couponData?.title}"</span> for a value of{" "}
                            <img src={coin} style={{ width: "17px", height: "20px", paddingBottom: "5px" }} alt="" />
                            {price}
                        </p>
                        {support_creator ? (
                            <div style={{
                                maxWidth: "280px",
                                margin: "12px auto 0",
                                padding: "16px",
                                border: "1px dashed #ccc",
                                borderRadius: "10px",
                                textAlign: "center",
                                background: "#fafafa",
                                color: "#111"
                            }}>
                                <p>Redeem Value: <strong><img src={coin} style={{ width: "17px", height: "20px", paddingBottom: "5px" }} alt="" />{price}</strong></p>
                                <p>Creator Discount (3%): <strong>- <img src={coin} style={{ width: "16px", height: "20px", paddingBottom: "5px" }} alt="" />{Math.round((price * 3) / 100)}</strong></p>
                                <hr style={{ margin: "12px 0" }} />
                                <p style={{ fontSize: "18px" }}>
                                    Final Redeem Value <br />
                                    <strong><img src={coin} style={{ width: "16px", height: "20px", paddingBottom: "5px" }} alt="" />{Math.round(price - (price * 3) / 100)}</strong>
                                </p>
                                <small><span className="text-danger">*</span> Creator discount applies automatically</small>
                            </div>
                        ) : null}

                        {redeemError ? (
                            <div className="uk-alert-danger uk-margin-small" style={{ marginTop: "12px" }}>
                                {redeemError}
                            </div>
                        ) : null}

                        <div className="redeem-confirm-actions">
                            <button
                                type="button"
                                className="uk-button uk-button-default"
                                onClick={() => {
                                    if (redeemBusy) return;
                                    setShowRedeemModal(false);
                                    setRedeemError("");
                                }}
                                disabled={redeemBusy}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="uk-button uk-button-danger"
                                onClick={confirmRedeem}
                                disabled={redeemBusy}
                                style={{ color: "#fff" }}
                            >
                                {redeemBusy ? "Please wait..." : "Yes, Redeem it!"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {onclose && (
                <PurchaseConfirmation couponData={{ couponData, voucher_code }} onClose={() => setonclose(false)} />
            )}
            <PhoneVerificationModal
                isOpen={showPhoneVerification}
                onClose={() => setShowPhoneVerification(false)}
                user={user}
                onVerified={(updatedUser) => {
                    setUser(updatedUser);
                    setShowPhoneVerification(false);
                    if (pendingRedeemPayload) {
                        const verifiedPayload = {
                            ...pendingRedeemPayload,
                            currentUser: {
                                ...pendingRedeemPayload.currentUser,
                                phone_verified: true,
                                phone_no: updatedUser?.phone_no || pendingRedeemPayload.currentUser?.phone_no
                            }
                        };
                        setRedeemPayload(verifiedPayload);
                        setRedeemError("");
                        setShowRedeemModal(true);
                        setPendingRedeemPayload(null);
                    }
                }}
                allowBypass={false}
                bypassLabel="Skip Verification"
                onBypass={() => {
                    if (pendingRedeemPayload) {
                        setRedeemPayload(pendingRedeemPayload);
                        setRedeemError("");
                        setShowRedeemModal(true);
                        setPendingRedeemPayload(null);
                    }
                }}
            />
        </>
    );
};

export default CouponPreview;




function price_updation(couponData, price, platform_coin_value) {
    // console.log("fadsfadsf",id);
    let value = document.querySelector(".shop-redeem input:checked");
    // console.log("pricein reedem", platform_coin_value);

    if (!value) {
        return price;
    }
    let label = document.querySelector(`label[for="${value.id}"]`);
    if (!label) {
        return price;
    }
    // couponData.price = label.textContent;
    // console.log(couponData);


    // let return_data = Number(myprice) * Number(platform_coin_value);
    var label_data = label.textContent.split('₹');
    //    console.log(label_data);

    let price_value = label_data[1];
    let return_data = Math.round(price_value) * platform_coin_value || 10;
    // console.log("text", price_value);

    return return_data;
}

function getStoredUser() {
    try {
        const raw = localStorage.getItem("user");
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : null;
    } catch (error) {
        return null;
    }
}

async function purchaseProduct(product_id, value, user_id, coupon_type, quantity_value = 1) {
    return makeAPI("/api/purchase", "POST", false, {
        product_id,
        value,
        user_id,
        coupon_type,
        quantity_value
    });
}
